var exports = {
  "M": "x61f99309--ec83a6--menu",
  "A": "x61f99309--ec83a6--item",
};

module.exports = exports;
